import ESign8821 from './components/ESign8821'

export default function ESign8821Page() {
  return (
    <div className='w-full h-full flex flex-col items-center p-6 overflow-hidden'>
      <div className='w-full flex-1 flex flex-col min-h-0 p-4'>
        <div className='mb-4 shrink-0 transition-colors duration-300'>
          <h1 className='text-3xl font-bold text-gray-900 dark:text-white text-center mb-2'>Form 8821 Electronic Signature</h1>
          <p className='text-gray-600 dark:text-slate-400 text-center text-sm'>Please complete the e-signature for Form 8821 to proceed.</p>
        </div>
        <div className='w-full flex-1 flex flex-col min-h-0'>
          <ESign8821 isResign={true} />
        </div>
      </div>
    </div>
  )
}
